import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface TriangulationServiceInterface {
  codEmpresa?: number;
  codUsu?: number;
  perfilUsu?: number;
  token: string;
  reqBody?: ReqBodyType;
}

class TriangulationService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listTriangulationData = async({
    codEmpresa,
    codUsu,
    perfilUsu,
    token,
  }: TriangulationServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_ArqTriangulacao?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilusu=${perfilUsu}`,
    });
  };

  uploadTriangulationData = async({
    codEmpresa,
    codUsu,
    perfilUsu,
    token,
    reqBody,
  }: TriangulationServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_ArqTriangulacao?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilusu=${perfilUsu}`,
      reqBody,
    });
  };

  handleFiltersSelect = async({
    codEmpresa,
    codUsu,
    perfilUsu,
    token,
    reqBody,
  }: TriangulationServiceInterface) => {
    return this.httpClient.post({
      token,
      path: `/api/SMob_ArqTriangPesquisa?codEmpresa=${codEmpresa}&codUsu=${codUsu}&perfilusu=${perfilUsu}`,
      reqBody,
    });
  };
}

export default new TriangulationService();
